/* @flow */
import { Container } from 'flux/utils';
import React from 'react';

import Activity from 'entities/Activity';
import ActivityStore from 'payments/stores/ActivityStore';
import ChatListActivities from 'chat/components/ChatListActivities.jsx';
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import User from 'entities/User';

type Props = {
  group: Group,
  selectedChatId?: ?string,
}

type State = {
  upcomingActivities: Activity[],
  currentUser: User,
};

class ChatListActivitiesContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [ActivityStore, CurrentUser];
  }

  static calculateState(prevState, props) {
    let upcomingActivities = ActivityStore.getUpcomingActivityForGroup(props.group);
    upcomingActivities = upcomingActivities.filter(activity => !!activity.getChatUuid());
    return {
      upcomingActivities,
      currentUser: CurrentUser.getUser(),
    };
  }

  render() {
    const props = {
      canCreateActivity: this.state.currentUser.canCreateActivity(),
      upcomingActivities: this.state.upcomingActivities,
    };

    return <ChatListActivities {...props} {...this.props} />;
  }
}

export default Container.create(ChatListActivitiesContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/chat/containers/ChatListActivitiesContainer.jsx